




























































































































































































import { Component, Prop } from 'vue-property-decorator'
import { AxiosResponse } from 'axios'
import { coreKaizen } from '@/common/coreKaizen'
import { certificacionModel } from '@/models/certificaciones/certificacionModel';
import { tipoEntidadModel } from '@/models/certificaciones/tipoEntidadModel';
import { tipoCertificacionModel } from '@/models/certificaciones/tipoCertificacionModel';

@Component
export default class certificacion extends coreKaizen {
    @Prop(String) ticket!: string

    snackBarText: string = ''
    snackbar: boolean = false
    validSolicitante: boolean = false
    boleta: string = ''
    telefonoSolicitanteLabel: string = 'Tel\u{e9}fono'
    direccionSolicitanteLabel: string = 'Direcci\u{f3}n del solicitante'
    emailSolicitanteLabel: string = 'Correo electr\u{f3}nico'
    isLoading: boolean = false
    tipoCertificacion: string = ''
    tipoEntidad: string = ''

    emptyEntidad: certificacionModel = {
        boleta: 0,
        certificacion: { correlativo: 0, ejercicio: 0 },
        registro: '',
        folio: 0,
        libro: 0,
        descripcion: '',
        expediente: { correlativo: 0, ejercicio: 0 },
        extranjera: false,
        fechaPublicacion: new Date(),
        fechaTra: new Date(),
        fechaTra2: new Date(),
        organizacion: '',
        solicitante: { nombre: '', telefono: '', direccion: '', dpi: '', e_mail: '' },
        ticket: 0,
        tipoCertificacion: 0,
        tipoEntidad: 0,
        titular: { numero: '', tipo: '' },
        referenceData: {
            dataFound: false, items: [
                {
                    titular: { numero: '', tipo: '' },
                    expediente: { correlativo: 0, ejercicio: 0 },
                    extranjera: false,
                    registro: '',
                    folio: 0,
                    libro: 0,
                    id: '',
                    name: '',
                    props: []
                }
            ]
        }
    }
    entidad: certificacionModel = this.emptyEntidad
    fileCounter: number = 100

    mounted() {
        if (this.ticket && !this.isLoading) {
            this.isLoading = true
            this.GilgameshApi.get(`certificaciones/${this.ticket}/certificacion/count`)
                .then(r => r as AxiosResponse<number>)
                .then(d => {
                    this.fileCounter = d.data
                }).then(() => {
                    if (this.allowDownload) {
                        this.GilgameshApi.get(`certificaciones/${this.ticket}`)
                            .then(r => r as AxiosResponse<certificacionModel>)
                            .then(d => {
                                this.entidad = d.data
                                return this.getTiposEntidad()
                            }).then(() => {
                                return this.getTiposCertificacion()
                            })
                    }
                })
                .catch(x => console.log('reason: ' + x))
                .finally(() => this.isLoading = false)
        }
    }

    get allowDownload() {
        return this.fileCounter <= 2
    }

    getFile() {
        this.GilgameshApi.get(`certificaciones/${this.ticket}/certificacion/file`, {
            responseType: 'arraybuffer'
        }).then(response => {
            this.forceFileDownload(response)
        }).catch(() => console.log('error occured'))
    }

    forceFileDownload(response: AxiosResponse<ArrayBuffer>) {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'certificado.pdf')
        document.body.appendChild(link)
        link.click()
    }

    getTiposCertificacion() {
        this.isLoading = true
        this.GilgameshApi.get('certificaciones/tipoCertificacion')
            .then(r => r as AxiosResponse<tipoCertificacionModel[]>)
            .then(d => {
                this.tipoCertificacion = (d.data.find(x => x.tipoCertificacion === this.entidad.tipoCertificacion) || { tipoCertificacion: 0, nombre: '' }).nombre
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    getTiposEntidad() {
        this.isLoading = true
        this.GilgameshApi.get('certificaciones/tipoEntidad')
            .then(r => r as AxiosResponse<tipoEntidadModel[]>)
            .then(d => {
                this.tipoEntidad = (d.data.find(x => x.tipoEntidad === this.entidad.tipoEntidad) || { tipoEntidad: 0, nombre: '' }).nombre
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    get hasLibro(): boolean {
        if (this.entidad.libro && this.entidad.libro > 0) {
            return true
        }
        return false;
    }

    get hasExpediente(): boolean {
        if (this.entidad.expediente) {
            return true
        }
        return false
    }

    get hasTitular(): boolean {
        if (this.entidad.titular && this.entidad.titular.numero) {
            return true
        }
        return false
    }
}
